module.exports = __webpack_public_path__ + "img/Foto_Tiziana_.6aeedd09.jpg";